<script setup lang="ts">
// The app's single currency mark. Every "AED" shown before an amount renders
// through here, so swapping the mark (text ↔ Dirham glyph), its size, or its
// spacing is a one-file change.
//
// Place it *inside* the amount's <Text> — it sizes itself in `em`, so it
// follows whatever `type` the surrounding text uses, and takes its colour.
//   <Text type="display" weight="bold"><CurrencySymbol />{{ amount }}</Text>
import { DirhamIcon } from '@uiKit/icons'
import { CURRENCY_CODE } from '@shared/utils'
</script>

<template>
  <DirhamIcon class="currency-symbol" role="img" :aria-label="CURRENCY_CODE" aria-hidden="false" />
</template>

<style scoped>
/* Height ≈ digit height of SF Pro; width follows the glyph's 35:30.8 ratio. */
.currency-symbol {
  display: inline-block;
  flex-shrink: 0;
  height: 0.72em;
  width: calc(0.72em * 35 / 30.8);
  margin-inline-end: 0.2em;
  vertical-align: baseline;
}
</style>
